import './NoAccountsPage.scss'
import React from 'react';
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';
import { smpCollegeSavingsProgramInfoLink } from 'services/Externals';


const SummitZeroStatePage = () => (
    <div data-testid={'program-benefits-page'}
         className="no-accounts-error-container">
        <WarningIcon className="no-accounts-icon" />
        <div className="no-accounts-error-title">
            We were unable to locate any accounts that are <br /> eligible for the T. Rowe Price Summit Program.
        </div>
        <div className="no-accounts-error-content">
            <a href={smpCollegeSavingsProgramInfoLink} className="no-accounts-contact-us-link">Learn more about the Summit Program</a>.
        </div>
    </div>
);

export default SummitZeroStatePage;
